export default "__VITE_ASSET__sV8UplVg__"